<template>
  <div id="app-counter">
    <secondHeader />
    <div class="main-counter">
      <sidebar />
      <div class="content-counter">
        <notice-bar />
          <h1 class="counter-title">デザインカウンター</h1>
        <div class="counter-container">
          <div class="counter-wrapper">
            <div v-if="counterLabel" class="counter-label" :style="{ fontFamily: selectedFont, color: textColor.hex }">
              {{ counterLabel }}
            </div>
            <h1 :class="backgroundClass" :style="[backgroundStyle, { fontFamily: selectedFont, color: textColor.hex }]">{{ count }}</h1>
          </div>
          <button @click="increment">+</button>
          <button @click="decrement">-</button>
        </div>
        <div class="counter-customization">
          <div class="left-counter-customization">
            <label>フォント選択:</label>
            <select v-model="selectedFont">
              <option value="'DotGothic16', sans-serif">DotGothic16</option>
              <option value="'Hachi Maru Pop', cursive">Hachi Maru Pop</option>
              <option value="'Monomaniac One', sans-serif">Monomaniac One</option>
              <option value="'Montserrat Alternates', sans-serif">Montserrat Alternates</option>
            </select>
            <label>背景色:</label>
            <select v-model="backgroundColor">
              <option value="transparent">透過</option>
              <option value="gradient1">グラデーション1</option>
              <option value="gradient2">グラデーション2</option>
              <option value="gradient3">グラデーション3</option>
              <option value="gradient4">グラデーション4</option>
            </select>
            <label>背景形状:</label>
            <select v-model="backgroundShape">
              <option value="square">四角</option>
              <option value="rounded">角丸</option>
              <option value="circle">丸</option>
            </select>
            <label>ラベルテキスト<br>(いらないときは消してOK):</label>
            <input v-model="counterLabel" type="text" placeholder="ラベルを入力">
          </div>
          <div class="right-counter-customization">
            <label>文字色:</label>
            <chrome-picker v-model="textColor" @input="updateTextColor" :disable="isGradientBackground" />
          </div>
        </div>
        <div class="counter-howto">
          <h2>使い方</h2>
          <div class="counter-howto-text">
            <p class="counter-howto-text-title">このページはカウンターのデザインをカスタマイズするためのページです。カスタマイズしたら下記の手順でOBSに追加していきます。</p>
            <p>1. OBS上部の「ドック」から「カスタムブラウザドック」を開きます。</p>
            <p>2. ドック名に「カウンター」、URLに「https://ruri.info/tool/countercontrol」を入力し適用を押します。</p>
            <p>3. ボタン付きのウィンドウが表示されます。これがカウントのためのコントローラーです。好きな場所に配置します。</p>
            <p>4. このページでデザインをカスタマイズしたら下記のボタンでリンクをコピーします。</p>
            <button @click="copyLink" class="counter-howto-copy-button">リンクをコピー</button>
            <p>5. OBSのブラウザソースを追加し、URL欄にコピーしたリンクを貼り付けます。</p>
            <p>以上で導入完了です。</p>
            <p>コントローラーで更新した値がブラウザソースに反映されます。</p>
          </div>
        </div>
        <div class="blog-area">
            <h2 class="blog-area-title">使い方はブログでチェック！</h2>
            <div class="blog-area-row">
              <div class="blog-area-thumb">
                <img class="article-list-img" src="@/assets/article/thomnail-counter.png">
              </div>
              <div class="blog-area-desc">
                <p>具体的な使い方や、おすすめのカスタマイズ方法はブログ記事で紹介しています。あわせてどうぞ！</p>
                <div class="blog-area-btn">
                  <a href="https://www.ruri.info/counter/" target="_blank" rel="noopener noreferrer">
                    <span class="check-btn">記事をチェック</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        <div class="ad-block">
          <div class="ad">
            <InFeedAdsense
                data-ad-layout-key="-fb+5w+4e-db+86"
                data-ad-client="ca-pub-9016794589237931"
                data-ad-slot="4898735474">
            </InFeedAdsense>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import secondHeader from "../components/secondHeader.vue"
import sidebar from "../components/sidebar.vue"
import noticeBar from "../components/notice-bar.vue"
import { Chrome } from 'vue-color'

export default {
  components:{
    secondHeader,
    sidebar,
    noticeBar,
    'chrome-picker': Chrome
  },
  data() {
    return {
      count: 0,
      selectedFont: "'DotGothic16', sans-serif",
      backgroundShape: 'square',
      backgroundColor: 'transparent',
      textColor: {
        hex: '#000000',
        hsl: { h: 0, s: 0, l: 0, a: 1 },
        hsv: { h: 0, s: 0, v: 0, a: 1 },
        rgba: { r: 0, g: 0, b: 0, a: 1 },
        a: 1
        },
      counterLabel: 'カウンター',
    }
  },
  computed: {
    backgroundClass() {
      return {
        'bg-square': this.backgroundShape === 'square',
        'bg-rounded': this.backgroundShape === 'rounded',
        'bg-circle': this.backgroundShape === 'circle'
      }
    },
    backgroundStyle() {
      let style = {};
      switch (this.backgroundColor) {
        case 'gradient1':
          style.background = 'linear-gradient(to right, #ff7e5f, #feb47b)';
          break;
        case 'gradient2':
          style.background = 'linear-gradient(to right, #6a11cb, #2575fc)';
          break;
        case 'gradient3':
          style.background = 'linear-gradient(to right, #D9AFD9, #97D9E1)';
          break;
        case 'gradient4':
          style.background = 'linear-gradient(to right, #bdc3c7, #2c3e50)';
          break;
        default:
          style.background = 'transparent';
          style.color = '#555';
      }
      return style;
    },
    isGradientBackground() {
      return ['gradient1', 'gradient2', 'gradient3', 'gradient4'].includes(this.backgroundColor);
    },
  },
  watch: {
    backgroundColor: {
      handler() {
        if (this.isGradientBackground) {
          this.textColor = {
            hex: '#ffffff',
            hsl: { h: 0, s: 0, l: 1, a: 1 },
            hsv: { h: 0, s: 0, v: 1, a: 1 },
            rgba: { r: 255, g: 255, b: 255, a: 1 },
            a: 1
          };
        }else{
          this.textColor = {
            hex: '#000000',
            hsl: { h: 0, s: 0, l: 0, a: 1 },
            hsv: { h: 0, s: 0, v: 0, a: 1 },
            rgba: { r: 0, g: 0, b: 0, a: 1 },
            a: 1
          };
        }
      },
      immediate: true
    }
  },
  methods: {
    increment() {
      this.count++;
    },
    decrement() {
      this.count--;
    },
    copyLink() {
      const url = new URL(window.location.href);
      url.pathname = '/tool/counterdesign';
      url.searchParams.set('count', this.count);
      url.searchParams.set('font', this.selectedFont);
      url.searchParams.set('shape', this.backgroundShape);
      url.searchParams.set('color', this.backgroundColor);
      url.searchParams.set('text', this.textColor.hex);
      navigator.clipboard.writeText(url.toString()).then(() => {
        alert('リンクがコピーされました');
      });
    },
    updateTextColor(color) {
      if (!this.isGradientBackground) {
        this.textColor = color;
      }
    }
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=DotGothic16&family=Hachi+Maru+Pop&family=Monomaniac+One&family=Montserrat+Alternates:wght@800&display=swap');

.ad-block{
  padding: 12px 0px;
  display: block;
  width: 100%;
}
.ad {
  max-height: 300px;
  max-width: 70%;
  margin: 0 auto;
  text-align: center;
  box-sizing: border-box;
  display: block;
}

#app-counter {
  min-height: 100vh;
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  margin: 0 auto;
}
.main-counter {
  min-height: 100vh;
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  margin: 0 auto;
}

.counter-title{
  text-align: center;
  letter-spacing: 2px;
  text-shadow: 2px 2px 6px rgb(210 210 210 / 80%);
  font-size: 1.5rem;
  color:#212121;
  font-weight: bold;
}

.content-counter {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: 60px 0 60px 1.82%;
  margin: 0 auto;
}

.counter-container {
  width: 500px;
  text-align: center;
  margin: 0 auto;
}

.counter-container h1 {
  font-size: 5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 200px;
  width: 200px;
  margin: 0 auto;
}

.counter-container button {
  font-size: 2rem;
  margin: 10px;
  padding: 10px 20px;
}

.counter-customization {
  margin: 20px 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
}

.left-counter-customization {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 10px;
}

.right-counter-customization {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: 10px;
}

.counter-customization label {
  margin-bottom: 10px;
}

.counter-customization select {
  width: 200px;
  margin-bottom: 20px;
}

.counter-customization button {
  margin-top: 20px;
}

.counter-howto {
  margin: 20px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.counter-howto h2 {
  margin-bottom: 10px;
}

.counter-howto-text {
  margin-bottom: 10px;
  text-align: left;
  width: 500px;
  line-height: 1.5;
}
.counter-howto-text-title {
  margin-bottom: 10px;
}
.counter-howto-copy-button {
  margin-bottom: 10px;
  padding: 10px 20px;
  background-color: #4c5c8a; /* 緑色の背景 */
  color: white; /* 白色の文字 */
  border: none; /* 枠線なし */
  border-radius: 5px; /* 角を丸くする */
  cursor: pointer; /* カーソルをポインターにする */
  transition: background-color 0.3s; /* 背景色の変化にアニメーションを追加 */
}

.counter-howto-copy-button:hover {
  background-color: #3b466a; /* ホバー時の背景色 */
}
.bg-square {
  border-radius: 0;
}

.bg-rounded {
  border-radius: 15px;
}

.bg-circle {
  border-radius: 50%;
}

.chrome-picker {
  margin-top: 10px;
}

.blog-block{
  margin-top:2rem;
}

.blog-area{
  padding: 20px;
  max-width: 620px;
  margin: 3rem auto;
  border-bottom: 1px solid #212121;
  border-top: 1px solid #212121;
}

.blog-area-title{
  margin-bottom: 20px;
  text-align: center;
  letter-spacing: 3px;
  text-shadow: 2px 2px 6px rgb(210 210 210 / 80%);
}

.blog-area-row{
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
  margin-top: 24px;
}

.blog-area-thumb{
  flex: 0 0 auto;
  margin-right: 20px;
  width: 50%;
}

.blog-area-thumb img{
    object-fit: contain;
    width: 100%;
}

.blog-area-desc{
  width: 50%;
  word-wrap: break-word;
  font-size: 14px;
  letter-spacing: 2px;
  text-align: left;
}

.blog-area-desc a{
  text-decoration:none;
}

.blog-area-btn{
  margin-top:2rem;
}

.check-btn{
  background-color: #212121;
  opacity: 0.75;
  border-radius: 8px;
  padding: 5px 12px ;
  color: white;
  transition: all .5s;
}

.check-btn:hover{
  box-shadow: 0px 5px 6px 0px rgba(0, 0, 0, 0.35);
	transform: translateY(-4px);
}

.counter-wrapper {
  position: relative;
  width: 200px;
  height: 200px;
  margin: 0 auto;
}

.counter-label {
  position: absolute;
  top: 13px;
  left: -5px;
  transform: rotate(-7deg);
  font-size: 1rem;
  color: #fff!important;
  font-weight: bold;
  z-index: 1;
  /* background-color: rgba(255, 255, 255, 0.7); */
  /* border: 1px solid #212121; */
  letter-spacing: 2px;
  background: #ffa4b0;
  padding: 8px 15px;
  border-radius: 5px;
}

.counter-container h1 {
  position: relative;
  z-index: 0;
}

.counter-label:before {
  position: absolute;
  content: '';
  top: 97%;
  left: 5px;
  border: none;
  border-bottom: solid 15px transparent;
  border-right: solid 20px #f87385;
}
</style>